<adaa-data-table
    #adaaDataTable
    apiName="getAllV2"
    apiPrefix="libmetric"
    paramsString="itemType=83"
    [titleHeader]="breadcrumb()"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.METRICS"
    [itemTypeId]="Constants.CONSTANT_PERMISSIONS.METRICS"
    [disableEditRules]="disableEditRules"
    [disableDeleteRules]="disableDeleteRules"
    (actionClicked)="getAction($event)"
    (addNewClicked)="addNew()"
/>

<adaa-metric-unlink-information #unlink [data]="relatedKpis()" />
